import { Col, Row } from "reactstrap";
import { ROLES_OPTIONS, STATUS_OPTIONS, TIMEZONE } from "@constants/panel/common";

import AsyncSelectField from "@components/fields/react-select/async-select";
import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import useFilters from "@src/views/common/hooks/use-filter";
import useUpsert from "./use-upsert";
import { useContext } from "react";
import { UserContext } from "@src/utility/context/user";
import PasswordField from "@src/@core/components/fields/password-field";

const UpsertUser = props => {
    const {
        handleModalConfig,
        modalConfig: { isOpen, row }
    } = props;

    const isEdit = !!row.id;
    const { userData:{ user:{ _id:userId } = {} } = {} } = useContext(UserContext);
    const { onSubmit, methods, updateLoading, isDirty } = useUpsert({
        ...props,
        isEdit
    });
    const { loadAsyncOptions } = useFilters();

    const {
        control,
        watch,
        formState: { errors }
    } = methods;
    const selectedProducts = watch("platforms");

    const content = [
        {
            leftChild: {
                title: "Basic Information",
                desc : "Please provide the basic information for the users."
            },
            rightChild: (
                <Row>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            id="name"
                            label="Name"
                            name="name"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            id="title"
                            label="Title"
                            name="title"
                            control={control}/>
                    </Col>
                    <Col lg={4}>
                        <InputField
                            errors={errors}
                            id="email"
                            label="Email"
                            name="email"
                            required
                            disabled={userId === row.id}
                            control={control}/>
                    </Col>
                    <Col>
                        <PasswordField
                            id="password"
                            name="password"
                            className="mb-1"
                            label="Password"
                            errors={errors}
                            control={control}/>
                    </Col>
                    <Col lg={4}>
                        <InputField
                            errors={errors}
                            type="number"
                            id="phone"
                            label="Phone Number"
                            name="phone"
                            control={control}/>
                    </Col>
                    <Col lg={4}>
                        <Select
                            options={ROLES_OPTIONS}
                            errors={errors}
                            label="Role"
                            name="role"
                            id="role"
                            disabled={userId === row.id}
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={STATUS_OPTIONS}
                            errors={errors}
                            label="Status"
                            name="status"
                            disabled={userId === row.id}
                            id="status"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={TIMEZONE}
                            errors={errors.region}
                            label="Timezone"
                            name="region.timezone"
                            id="timezone"
                            control={control}/>
                    </Col>
                    <Col lg={12}>
                        <AsyncSelectField
                            loadOptions={(value, callback) => {
                                loadAsyncOptions({ value, callback, type: "products" });
                            }}
                            defaultOptions
                            id="platforms"
                            isMulti
                            isClearable
                            label="Products"
                            name="platforms"
                            required
                            control={control}
                            errors={errors}/>
                    </Col>
                    
                    {selectedProducts?.length > 0 && (
                        <Col lg={12}>
                            <AsyncSelectField
                                key={selectedProducts.map(p => p.value).join(",")} 
                                loadOptions={(value, callback) => {
                                    loadAsyncOptions({
                                        value,
                                        callback,
                                        type   : "user",
                                        context: {
                                            products: selectedProducts.map(p => p.value).join(",")
                                        }
                                    });
                                }}
                                defaultOptions
                                id="tags"
                                isMulti
                                isClearable
                                label="Tags"
                                name="tags"
                                control={control}
                                errors={errors}/>
                        </Col>
                    )}                        
                </Row>
            )
        }
    ];
    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} User`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="extraLarge"
            isDirty={isDirty}
            handleModal={handleModalConfig}
            isOpen={isOpen}/>
    );
};
export default UpsertUser;
